import React, { ReactElement } from 'react';
import { findDocumentTypesFor } from "../../enums/BenefitType";
import _ from "lodash";
import Start from "../../common/Start";
import { useFormikContext } from "formik";
import { FormValues } from "../../common/FormValues";

const EmployeeStart = () => {
    const { values } = useFormikContext<FormValues>();
    const documentTypes = findDocumentTypesFor(values);
    const neededItems = [
        'Contact information of your employer',
        'The claim dates you\'re requesting',
        'Bank account information for direct deposit (if desired)'
    ] as (ReactElement | string)[];
    if(documentTypes.length) {
        neededItems.push(<strong>
            Any supporting documentation
            (e.g. {documentTypes.map(type => _.lowerFirst(type)).join(', ')})
        </strong>)
    }
    return (
        <Start neededItems={neededItems}/>
    )
};

export default EmployeeStart;